/**
 * Module dependencies
 */
const HelpCard = require('./lib/HelpCard');
const { CxWidget } = require('./lib/CxWidget').CxWidget;
const { getHelpCardData } = require('./lib/getHelpCardData');

/**
 * Expose HelpCard
 */
/**
 * The React Component for the help-card.
 *
 * eg: <HelpCard {...helpCardData} clickDelay={3000} />
 *
 * For more information visit: https://meli.workplace.com/notes/ayuda-contextual/gu%C3%ADa-de-implementaci%C3%B3n-de-help-card/1835330256622585
 *
 * @param {object} ...helpCardData - The response of getHelpCardData function.
 * @param {object} clickDelay - (optional) ms to wait before enabling buttons.
 */
module.exports = HelpCard;

/**
 * Opens a widget given a config.
 *
 * For more information visit: https://meli.workplace.com/notes/ayuda-contextual/gu%C3%ADa-de-implementaci%C3%B3n-del-widget-de-ayuda/877897946363413
 *
 * @param {object} config - The config object including all nescesary data to open a widget.
 * @param {object} options - (optional) Additional options such as method to use in request.
 * @param {object} element - (optional) An HTML element to focus back on close.
 */
module.exports.CxWidget = CxWidget;
/**
 * Gets the helpCardData for the HelpCard component given a config.
 *
 * For more information visit: https://meli.workplace.com/notes/ayuda-contextual/gu%C3%ADa-de-implementaci%C3%B3n-de-help-card/1835330256622585
 *
 * @param {object} config - The config object including all nescesary data to open a widget.
 * @param {object} device - the req.device object provided by nordic.
 * @param {object} platform - the req.platform object provided by nordic.
 * @param {object} meliContext - the trazability object provided by nordic/restclient/build-context.
 */
module.exports.getHelpCardData = getHelpCardData;

